export default () => {
  return Math.random().toString(35).substr(2, 10);
};


// WEBPACK FOOTER //
// ./src/utils/generateId.ts